import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["modal", "bottom", "top", "list", "view", "radars", "bodyTable", "footerTable", "body", "searchTable", "searchInput"]

  connect() {
    this.controllerName = `commercial--sales--opportunities--radars--save-modal`
    this.controllerNumber = this.getControllerByIdentifier(`app--helpers--numbers`)
  }

  open() {
    document.body.classList.add("modal-open");
    this.element.setAttribute("style", "display: block;");
    this.element.classList.add("show");
    const html = `<div class="modal-backdrop fade show"></div>`
    // document.body.insertAdjacentHTML("beforeend", html)
    var controller = this
    new Promise(function (resolve) {
      resolve(document.body.insertAdjacentHTML("beforeend", html))
    }).then(() => {
      controller.doFormHtml()
    })
  }

  close() {
    document.body.classList.remove("modal-open");
    this.element.removeAttribute("style");
    this.element.classList.remove("show");
    document.getElementsByClassName("modal-backdrop")[0].remove();
    this.modalTarget.remove()
  }

  doFormHtml() {
    var html = `<div class="col-12 px-0" data-${this.controllerName}-target="radars" data-controller="commercial--sales--opportunities--radars--save"></div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.bodyTarget.innerHTML = html)
    }).then(() => {
      controller.controllerSaveContract = controller.getControllerByIdentifier("commercial--sales--opportunities--radars--save")
      controller.controllerSaveContract.controllerDashboard = controller
      controller.controllerSaveContract.permission = controller.permission
      controller.controllerSaveContract.gridElement = controller.radarsTarget
      controller.controllerSaveContract.current_opportunity = controller.current_opportunity
      controller.controllerSaveContract.actionMode = controller.actionMode
      controller.controllerSaveContract.doFormHtml()
    })
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }
}